"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeService = void 0;
var datatypes_1 = require("./datatypes/datatypes");
var CodeService = /** @class */ (function () {
    function CodeService(valueSetsJson) {
        if (valueSetsJson === void 0) { valueSetsJson = {}; }
        this.valueSets = {};
        for (var oid in valueSetsJson) {
            this.valueSets[oid] = {};
            for (var version in valueSetsJson[oid]) {
                var codes = valueSetsJson[oid][version].map(function (code) { return new datatypes_1.Code(code.code, code.system, code.version); });
                this.valueSets[oid][version] = new datatypes_1.ValueSet(oid, version, codes);
            }
        }
    }
    CodeService.prototype.findValueSetsByOid = function (oid) {
        return this.valueSets[oid] ? Object.values(this.valueSets[oid]) : [];
    };
    CodeService.prototype.findValueSet = function (oid, version) {
        if (version != null) {
            return this.valueSets[oid] != null ? this.valueSets[oid][version] : null;
        }
        else {
            var results = this.findValueSetsByOid(oid);
            if (results.length === 0) {
                return null;
            }
            else {
                return results.reduce(function (a, b) {
                    if (a.version > b.version) {
                        return a;
                    }
                    else {
                        return b;
                    }
                });
            }
        }
    };
    return CodeService;
}());
exports.CodeService = CodeService;
//# sourceMappingURL=cql-code-service.js.map